import type { AztecAddress } from "@aztec/aztec.js";
import { getL2ClientAsync } from "../aztec-utils";
import { getL2TokenFromL2Address } from "../lib/singletons";

export async function doShield(l2TokenAddress: AztecAddress, amount: bigint) {
  const l2Client = await getL2ClientAsync();
  const token = await getL2TokenFromL2Address(l2TokenAddress.toString());

  const symbol = await token.getSymbol();
  console.log(`Shielding ${amount} ${symbol}...`);

  const balance = await token.balanceOfPublic(l2Client.getAddress()).simulate({ from: l2Client.getAddress() });
  console.log(`Current balance: ${balance}`);
  if (balance < amount) {
    throw new Error("Insufficient balance.");
  }

  const tx = await token.shield(amount).send({ from: l2Client.getAddress() });
  const txHash = await tx.getTxHash();
  console.log(`Transaction submitted: ${txHash}`);

  return tx;
}

export async function doUnshield(l2TokenAddress: AztecAddress, amount: bigint) {
  const l2Client = await getL2ClientAsync();
  const token = await getL2TokenFromL2Address(l2TokenAddress.toString());

  const symbol = await token.getSymbol();
  console.log(`Unshielding ${amount} ${symbol}...`);

  const balance = await token.balanceOfPrivate(l2Client.getAddress()).simulate( { from: l2Client.getAddress() } );
  console.log(`Current private balance: ${balance}`);
  if (balance < amount) {
    throw new Error("Insufficient balance.");
  }

  const tx = await token.unshield(amount).send({ from: l2Client.getAddress() });
  const txHash = await tx.getTxHash();
  console.log(`Transaction submitted: ${txHash}`);
  return tx;
}
